import { render } from "./Order-print.vue?vue&type=template&id=7567abcd"
import script from "./Order-print.vue?vue&type=script&lang=js"
export * from "./Order-print.vue?vue&type=script&lang=js"

import "./Order-print.vue?vue&type=style&index=0&id=7567abcd&lang=less"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\wxPrint2\\adminVue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__